import type {
	InputOptions,
	InputSelectOptions,
} from '@features/filters/interfaces/filters.interfaces';
import { Clear } from '@mui/icons-material';
import { IconButton, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { handleInputTextClearClick } from './FiltersContainer.handlers';

export function generateInput<Form>(id: string, input: InputOptions<Form>): React.ReactElement {
	return (
		<Controller
			control={input.control}
			defaultValue={input.defaultValue}
			name={input.name}
			render={({ field: { onChange, value } }) => {
				if (
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					((o: any): o is InputSelectOptions<Form, any> => o.options != undefined)(input)
				) {
					return (
						<Select
							onChange={onChange}
							size="small"
							sx={{
								width: input.width,
								background: 'white',
								fontSize: 12,
								color: '#000000DE',
							}}
							value={value}
						>
							{input.options.map((option, i) => (
								<MenuItem
									key={`${id}_${input.name}_option_${i}`}
									value={option.value}
								>
									{option.label}
								</MenuItem>
							))}
						</Select>
					);
				}

				const onChangeText = input.onChange ? input.onChange(onChange) : onChange;

				const hasValue = (value as string).length > 0;

				return (
					<TextField
						InputProps={{
							endAdornment: value ? (
								<InputAdornment position="end">
									<IconButton
										onClick={handleInputTextClearClick(
											onChangeText,
											input.onClear
										)}
										size="small"
									>
										<Clear fontSize="small" />
									</IconButton>
								</InputAdornment>
							) : undefined,
							startAdornment: input.startAdorment ? (
								<InputAdornment position="start">
									{input.startAdorment}
								</InputAdornment>
							) : undefined,
						}}
						onChange={onChangeText}
						onKeyPress={input.onKeyPress}
						placeholder={input.placeholder}
						size="small"
						disabled={input.disabled}
						sx={{
							backgroundColor: hasValue ? undefined : '#ECECEC !important',
							width: input.width,
							'& fieldset, &:hover fieldset': {
								borderColor: hasValue ? undefined : 'transparent',
							},
							borderRadius: '5px !important',
							fontSize: 12,
							'& input::placeholder': {
								fontSize: '12px',
							},
						}}
						value={value}
						variant="outlined"
					/>
				);
			}}
		/>
	);
}
